import React, { createContext, useContext, useState } from "react";
import ServiceSelectModal from "../components/ServiceSelectModal";

const BookingCtx = createContext(null);
export const useBooking = () => useContext(BookingCtx) || { openBook: () => {}, openService: () => {} };

export function BookingProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [therapyIdx, setTherapyIdx] = useState(null);
  const openBook = () => { setTherapyIdx(null); setOpen(true); };
  const openService = (i) => { setTherapyIdx(i); setOpen(true); };
  return (
    <BookingCtx.Provider value={{ openBook, openService }}>
      {children}
      <ServiceSelectModal open={open} therapyIndex={therapyIdx} onClose={() => setOpen(false)} />
    </BookingCtx.Provider>
  );
}
